import React, { useCallback, useRef, useEffect } from 'react'
import { browserHistory } from 'react-router'
import Datagrid from '../../Component/Datagrid/index'
import User from 'EurestoClass/User'

export default React.memo(props => {

  const metaKeyPressed = useRef(false);
  const handleMetaKeyDown = e => {
    if (e.ctrlKey) {
      metaKeyPressed.current = true;
    }
  };

  const handleMetaKeyUp = e => {
    metaKeyPressed.current = false;
  };

  useEffect(() => {
    document.addEventListener('keydown', handleMetaKeyDown);
    document.addEventListener('keyup', handleMetaKeyUp);
    window.addEventListener('blur', handleMetaKeyUp);
    return () => {
      document.removeEventListener('keydown', handleMetaKeyDown);
      document.removeEventListener('keyup', handleMetaKeyUp);
      window.removeEventListener('blur', handleMetaKeyUp);
    };
  }, []);

  const update = useCallback((row) => {
    if (!metaKeyPressed.current) {
      browserHistory.push({
        pathname: '/crm/' + row.contact_id,
        state: {
          dossier_id: row.dossier_id && row.dossier_id || undefined,
          classeur_id: row.classeur_id,
          action_id: row.action_id,
          UserTabSelected: 2,
          dossier_status: row.status
        }
      })
    } else {
      window.open(`/crm/${row.contact_id}?action_id=${row.action_id}&UserTabSelected=2&classeur_id=${row.classeur_id}&dossier_status=${row.status}${row.dossier_id && row.dossier_id && `&dossier_id=${row.dossier_id && row.dossier_id}` || ""}`);
    }
  }, [])

  return <Datagrid onClick={update}
    type="dossier"
    search={'dossier_' + (props.name || '') + User.Entite.get().id} />
})





// WEBPACK FOOTER //
// ./app/App/Module/SDD/Page/Recherche/index.js